<template>
  <LocationSelectorCold
    v-if="!hotReload"
    :singleLocation="singleLocation"
    :onlyActiveLocations="onlyActiveLocations"
  />
  <LocationSelectorHot
    v-else
    :singleLocation="singleLocation"
    :onlyActiveLocations="onlyActiveLocations"
  />
</template>

<script>
import { defineComponent } from "vue";
import LocationSelectorCold from "./cold/LocationSelector.vue";
import LocationSelectorHot from "./hot/LocationSelector.vue";

export default defineComponent({
  name: "LocationSelector",
  components: {
    LocationSelectorCold,
    LocationSelectorHot,
  },
  props: {
    hotReload: {
      type: Boolean,
      default: false,
    },
    singleLocation: {
      type: Boolean,
      default: false,
    },
    onlyActiveLocations: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style scoped>
.selector-container {
  display: flex;
  gap: 5px;
  align-items: center;
}
.selector {
  max-width: 150px;
}
</style>